const MAX_LOG_LINES = 6000;

let logLines = [];
const listeners = new Set();

const notify = () => {
  listeners.forEach((listener) => listener());
};

export const subscribeImportLogStore = (listener) => {
  listeners.add(listener);
  return () => listeners.delete(listener);
};

export const getImportLogLines = () => logLines;

export const setImportLogLines = (updater) => {
  const next = typeof updater === "function" ? updater(logLines) : updater;
  logLines = next.length > MAX_LOG_LINES ? next.slice(-MAX_LOG_LINES) : next;
  notify();
};

export const clearImportLogStore = () => {
  logLines = [];
  notify();
};

export const MAX_IMPORT_LOG_LINES = MAX_LOG_LINES;
